"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormSelect = void 0;
const react_1 = __importDefault(require("react"));
const FormField_1 = require("../base/FormField");
const FieldWrapper_1 = require("./FieldWrapper");
class FormSelect extends FormField_1.FormField {
    render() {
        return (react_1.default.createElement(FieldWrapper_1.FormFieldWrapper, Object.assign({}, this.wrapperProps),
            react_1.default.createElement("select", { value: this.value, onChange: e => this.setValue(e.target.value), className: "form__select" },
                this.props.nullable ? react_1.default.createElement("option", { value: undefined }, "---") : null,
                this.props.options.map((option, index) => (react_1.default.createElement("option", { key: index, value: option.value }, option.label)))),
            react_1.default.createElement("div", { className: "form__select-arrow" }, "keyboard_arrow_down")));
    }
}
exports.FormSelect = FormSelect;
//# sourceMappingURL=Select.js.map